import { FormBase } from 'core/components';

export default class PumpCreateForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'productId',
                    label: 'PUMPS.EDIT.PRODUCT_LABEL',
                    placeholder: 'PUMPS.EDIT.PRODUCT_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: 'serialNumber',
                    label: 'PUMPS.EDIT.SERIAL_NUMBER_LABEL',
                    placeholder: 'PUMPS.EDIT.SERIAL_NUMBER_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: 'dateSent',
                    label: 'PUMPS.EDIT.DATE_SENT_LABEL',
                    placeholder: 'PUMPS.EDIT.DATE_SENT_PLACEHOLDER',
                    rule: 'required'
                },
                {
                    name: 'stickered',
                    type: 'bool',
                    value: true
                },
                {
                    name: 'branch',
                    label: 'PUMPS.EDIT.BRANCH_LABEL',
                    rules: 'string|required',
                    value: 'Lakewood'
                },
            ],
        };
    }
}
